import { render, staticRenderFns } from "./Ship.vue?vue&type=template&id=2e5cad0c&"
import script from "./Ship.vue?vue&type=script&setup=true&lang=js&"
export * from "./Ship.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Ship.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports